import {createProperty} from './utils/createProperty'

/**
 * The annotation builder for a component property with type 'string'.
 */
export const string = createProperty('string').typed('string').localize
